/**
 * 菜单项
 *
 * @author chitanda
 * @date 2021-03-18 11:03:14
 * @export
 * @interface ContextMenuItem
 */
export interface ContextMenuItem {
  /**
   * 可充当唯一标识
   *
   * @author chitanda
   * @date 2021-03-18 16:03:12
   * @type {string}
   */
  tag?: string;
  /**
   * 展示文本
   *
   * @author chitanda
   * @date 2021-03-18 09:03:17
   * @type {string}
   */
  text?: string;
  /**
   * 图标
   *
   * @author chitanda
   * @date 2021-03-18 11:03:07
   * @type {string}
   */
  icon?: string;
  /**
   * 右键菜单右侧展示文本
   *
   * @author chitanda
   * @date 2021-03-18 09:03:25
   * @type {string}
   */
  textRight?: string;
  /**
   * 提示信息
   *
   * @author chitanda
   * @date 2021-03-18 09:03:35
   * @type {string}
   */
  tooltip?: string;
  /**
   * 菜单类型
   *
   * @default 'menu'
   * @author chitanda
   * @date 2021-03-18 10:03:27
   * @type {('menu' | 'separator')}
   */
  type?: 'menu' | 'separator';
  /**
   * 子菜单模式
   *
   * @author chitanda
   * @date 2022-03-23 17:03:02
   * @type {('menu' | 'embed-icon')} menu: 标准模式，embed-cion: 嵌入图标模式
   */
  subMode?: 'menu' | 'embed-icon';
  /**
   * 是否禁用
   *
   * @default false
   * @author chitanda
   * @date 2021-03-18 13:03:23
   * @type {boolean}
   */
  disable?: boolean;
  /**
   * 子菜单
   *
   * @author chitanda
   * @date 2021-03-18 11:03:38
   * @type {ContextMenuItem[]}
   */
  children?: ContextMenuItem[];
  /**
   * 携带额外参数
   *
   * @author chitanda
   * @date 2021-03-18 11:03:33
   * @type {*}
   */
  data?: any;
}
